import { ButtonsProviderService } from '@addins/core/singlecallcard';
import { AttachmentService, MediaSource } from '@addins/media';
import { Injectable } from '@angular/core';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { ProfileService } from '@services/profile/profile.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs';
import { AddAttachmentCardButton } from '../../../schema/add-attachment-card-button';
import { AttachmentsCardButton } from '../../../schema/attachments-card-button';
import { SINGLECALLCARD_ATTACHMENTS } from '../../../schema/constants';
import { AddAttachmentCardButtonControllerService } from '../../add-attachment-card-button-controller/add-attachment-card-button-controller.service';
import { AttachmentsCardButtonControllerService } from '../../attachments-card-button-controller/attachments-card-button-controller.service';

@AddinExecute({
  name: 'CardButtons'
})
@Injectable()
export class CardButtonsService extends Execute {
  private attachmentsCardButton: AttachmentsCardButton = null;
  private addAttachmentCardButton: AddAttachmentCardButton = null;

  constructor(
    private buttonsProvider: ButtonsProviderService,
    private profileService: ProfileService,
    private profileReader: ProfileReaderService,
    private attachmentsButtonController: AttachmentsCardButtonControllerService,
    private addAttachmentButtonController: AddAttachmentCardButtonControllerService,
    private attachmentService: AttachmentService
  ) {
    super();
  }

  execute() {
    this.profileService.ready
      .pipe(
        filter(isReady => isReady),
        first()
      )
      .subscribe(() => this.onProfileReady());
  }

  private onProfileReady() {
    this.attachmentsCardButton = new AttachmentsCardButton();
    this.attachmentsButtonController.setup(this.attachmentsCardButton);
    this.buttonsProvider.add(this.attachmentsCardButton);

    const addAttachmentSources: string[] = this.profileReader.getComponentConfig(SINGLECALLCARD_ATTACHMENTS, 'canAddAttachmentFrom', []);
    if (addAttachmentSources.length) {
      this.addAttachmentCardButton = new AddAttachmentCardButton();
      this.addAttachmentButtonController.setup(this.addAttachmentCardButton);
      this.buttonsProvider.add(this.addAttachmentCardButton);

      const mediaSources: MediaSource[] = [];
      addAttachmentSources.forEach(attachmentSource => mediaSources.push(MediaSource[attachmentSource]));
      this.attachmentService.setAttachmentMediaSources(mediaSources);
    }
  }
}
